export function useNaiveNotification() {
  function create(opts) {
    if (import.meta.client) {
      window.dispatchEvent(
        new CustomEvent("naiveui:notification:create", { detail: opts })
      );
    }
  }
  return { create };
}
